import UserMessage from '../ChatWidget/UserMessage';
import AIMessage from '../ChatWidget/AIMessage';
import SessionClosed from '../ChatWidget/SessionClosed';
import chatEventEmitter from '../ChatWidget/chatEventEmitter';
import Selector from './Selector';
import AiSearch from './AiSearch';
import Button from '../legacy/core/Button';
import { createAnimatedAdditionalContent } from '../../wp_helpers/aiHelpers';
import renderPage from '@helpers/renderPage';
import { getUid } from '@helpers/helpers';
import pageContext from '@helpers/pageContext';
import '@helpers/pageContextProviders';

const TAHireAssistants = {
    job_desc: {
        selectors: {
            'selector-1': new Selector(
                'ckEditor',
                () => CKEDITOR.instances['new_job-job_description'],
            ),
        },
        preGenerateFunc: (callback) => {
            updateFormData('generate_job_description', callback);
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Job Description Generation');
            callback();
        },
    },
    job_desc_translation: {
        selectors: {
            'selector-1': new Selector(
                'ckEditor',
                () => CKEDITOR.instances['new_job-job_description'],
            ),
        },
        getAdditionalParams: () => {
            const queryParams = new URLSearchParams(window.location.search);
            const lang = queryParams.get('lang');
            let params = {};
            if (lang) {
                params = {...params, target_language: lang};
            }
            return params;
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Job Description Generation');
            callback();
        },
    },
    application_notes_summary: {
        selectors: {
            'selector-1': new Selector('text', () => {
                const hash = $('.notepad-title.is-active').data('hash');
                return $(`#${hash}_ai_text`);
            }),
        },
        getAdditionalParams: () => {
            const hash = $('.notepad-title.is-active').data('hash');
            let params = {};
            if (hash) {
                params = {...params, notepad_id: hash};
            }
            return params;
        },
        preGenerateFunc: (callback) => {
            const hash = $('.notepad-title.is-active').data('hash');
            $(`#panel-collapse-${hash}`).collapse('show');

            callback();
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Application Notes Summary');
            callback();
        },
    },
    application_fields_summary: {
        selectors: {
            'selector-1': new Selector('text', () => $(`#application_fields_summary_ai_text`)),
        },
        getAdditionalParams: () => {
            const anonymous_recruitment = $('#applicant-attributes').data('anonymous_recruitment');
            let params = {anon: anonymous_recruitment ? 1 : 0};
            return params;
        },
        preGenerateFunc: (callback) => {
            $(`#panel-collapse-application_fields_summary`).collapse('show');

            callback();
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Application Summary');
            callback();
        },
    },
    application_fields_structured_summary: {
        selectors: {
            'selector-1': new Selector('structured_form', () =>
                $(`#application_fields_structured_summary_ai_text`),
            ),
        },
        getAdditionalParams: () => {
            const anonymous_recruitment = $('#applicant-attributes').data('anonymous_recruitment');
            let params = {anon: anonymous_recruitment ? 1 : 0};
            return params;
        },
        preGenerateFunc: (callback) => {
            $(`#panel-collapse-application_fields_structured_summary`).collapse('show');

            callback();
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Application Structured Summary');
            callback();
        },
    },
    application_insights_assistant: {
        selectors: {
            'selector-1': new Selector('application_listing', () =>
                $(`#talents_datatable`),
            ),
        },
        button: (title, onClick, className, options = {}) => {
            return <AiSearch onClick={onClick} className={className} placeholder={title}></AiSearch>
        },
        errorCallback: (response, notify) => {
            const { error } = response;
            $('.ai-response-row').remove();
            $(".ai-search-input").attr("data-search-triggered", "false");
            $(".ai-search-input").attr("contenteditable", true);
            notify(error);
        },
        getAdditionalParams: () => {
            let params = {}
            var applicationIds = [];
            $('.talent-table tbody tr:not(.ai-response-row)').each(function () {
                const hash = $(this).data('hash');
                if (hash) {
                    applicationIds.push(hash);
                }
            });
            const userPrompt = $("#user_prompt").val();
            if (userPrompt) {
                params = {...params, "user_prompt": userPrompt}
            }
            if (applicationIds.length > 0) {
                params = {...params, "entities": {"application_ids": applicationIds}}
            }
            return params;
        },

        preGenerateFunc: (callback) => {
            $('.ai-response-row').remove();
            $(".ai-search-input").attr("data-search-triggered", "true");
            $(".ai-search-input").attr("contenteditable", false);
            const totalColumns = $("#talents_datatable tbody tr").eq(0).find('td').length;
            $('.talent-table tbody tr').each(function () {
                const hash = $(this).data('hash');
                if (hash) {
                    const application = { application_hash: hash, result: global_i18n("Processing Insights, please wait...") };
                    createAnimatedAdditionalContent(application, totalColumns);
                }
            });

            callback();
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Application Listing Insights');
            $('.data-table-loader').hide();
            callback();
        },
    },
    job_skills_recommendation: {
        selectors: {
            'selector-1': new Selector('ai_job_skills_recommendation', () =>
                $(`#ai_job_skills_recommendation`),
            ),
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Application Skills Recommendation');
            callback();
        },
    },
    feedback_generation_assistant : {
        getAdditionalParams: () => {
            const feedbackLanguage = $('#feedback-langauge').val();
            const params = {};
            if (feedbackLanguage) {
                params.feedback_language = feedbackLanguage;
            }
            return params;
        },
        selectors: {
            "selector-1": new Selector("ckEditorTemplate", () => CKEDITOR.instances['message']),
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Feedback Generation');
            callback();
        },
    },
    support_chat_assistant: {
        selectors: {
            'selector-1': new Selector('text', () => $('.message.ai .message_content .message_text').last(),
            ),
        },
        // The trigger sits inside the chat widget's message row, where there is no room
        // for a label — so it is the icon-only AI button, with the assistant's own title
        // carried as the accessible name and tooltip instead of rendered text.
        button: (title, onClick, className, { disabled } = {}) => (
            <Button
                type="ai"
                size="xxs"
                onlyIcon
                className={className}
                altTitle={title}
                aria-label={title}
                disabled={disabled}
                onClick={onClick}
            />
        ),
        getAdditionalParams: () => {
            const userPrompt = $('.chat_input input').val();
            const params = {};
            if (userPrompt) {
                params.user_prompt = userPrompt;
            }
            return params;
        },
        preGenerateFunc: (callback) => {
            const userPrompt = $('.chat_input input').val();

            if (userPrompt) {
                const containerId = `chat-message-${getUid()}`;
                $('<div></div>').attr('id', containerId).appendTo('.chat_body');
                renderPage(containerId, () => (
                    <><UserMessage message={userPrompt} /><AIMessage message='' loading /></>
                ));
                $('.chat_messages').scrollTop($('.chat_messages')[0].scrollHeight);
                $('.chat_input input').attr("disabled", true);

            }

            callback();
        },
        postGenerateFunc: (callback) => {
            const containerId = `chat-message-${getUid()}`;
            $('<div></div>').attr('id', containerId).appendTo('.chat_body');
            if (typeof usageTrackEvent === 'function') {
                usageTrackEvent('ai support agent question asked');
            }
            $('.chat_messages').scrollTop($('.chat_messages')[0].scrollHeight);
            $('.chat_input input').attr("disabled", false);
            chatEventEmitter.emit("clearInput");
            const supportGuideLink = $('.message.ai .message_content .message_text').last().data("supportGuideLink");
            renderPage(containerId, () => (
                <><SessionClosed supportGuideLink={supportGuideLink} /></>
            ));
            callback();
        }
    },
    conversational_ui_assistant: {
        selectors: {
            'selector-1': new Selector('conversational_ui_assistant_widget', () => {
                // Return the chat API instance instead of a DOM element
                // This is set globally in conversational_ui_assistant.jsx
                return window.conversationalChatApi;
            }),
        },
        button: (title, onClick, className, { disabled } = {}) => {
            const isCancel = className === 'btn-loading';
            return (
                <Button
                    type="primary"
                    className="send-button"
                    onClick={onClick}
                    icon={isCancel ? 'icon-svg-x-close' : 'icon-svg-arrow-up'}
                    disabled={isCancel ? false : disabled}
                    altTitle={isCancel ? title : undefined}
                />
            );
        },
        getAdditionalParams: () => {
            // Get the prompt from temporary storage (set in preGenerateFunc)
            // or fall back to reading from textarea if not cleared yet
            const userPrompt = window._tempUserPrompt || $('.chatbox-input-container textarea').val();
            const params = {};
            if (userPrompt) {
                params.user_prompt = userPrompt;
                // Use the actual chat ID from the loaded chat, or generate a temporary one
                params.chat_id = window.conversationalCurrentChatId || `temp_${Date.now()}`;
                // What the user is looking at — hints for the assistant's reference
                // resolution; the backend tenant-checks every ref before use.
                params.view_context = pageContext.snapshot();
            }
            
            // Clean up temporary storage after use
            delete window._tempUserPrompt;
            
            return params;
        },
        preGenerateFunc: (callback) => {
            const userPrompt = $('.chatbox-input-container textarea').val();
            const chatApi = window.conversationalChatApi;

            if (!userPrompt || !chatApi) {
                callback();
                return;
            }

            window._tempUserPrompt = userPrompt;
            chatApi.addMessage({ type: 'user', text: userPrompt });
            chatApi.setGenerating(true);
            if (typeof window.conversationalClearInput === 'function') {
                window.conversationalClearInput();
            }

            const needsChat = !window.conversationalCurrentChatId;
            setTimeout(() => {
                chatApi.addMessage({
                    type: 'thinking',
                    text: needsChat ? (chatApi.t ? chatApi.t('Initializing chat') : 'Initializing chat') : undefined,
                });
            }, 100);

            const proceed = () => {
                // Swap the "Initializing chat" loader for the default "Thinking" one
                // now that the chat exists on the server.
                if (needsChat) {
                    chatApi.removeThinkingMessage();
                    chatApi.addMessage({ type: 'thinking' });
                }
                callback();
            };

            if (needsChat && typeof chatApi.ensureChatCreated === 'function') {
                Promise.resolve(chatApi.ensureChatCreated())
                    .then(proceed)
                    .catch((err) => {
                        chatApi.removeThinkingMessage();
                        chatApi.setGenerating(false);
                        console.error('Failed to create chat:', err);
                    });
            } else {
                callback();
            }
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Conversational UI Message');
            window.conversationalChatApi?.setGenerating(false);
            callback();
        },
        cancelCallback: () => {
            const chatApi = window.conversationalChatApi;
            chatApi?.removeThinkingMessage();
            chatApi?.setGenerating(false);
        },
        errorCallback: (responseData, notify) => {
            const chatApi = window.conversationalChatApi;
            chatApi?.removeThinkingMessage();
            chatApi?.setGenerating(false);
            if (responseData.chat_status === 'limit_reached') {
                chatApi?.setApproachingLimit(false);
                chatApi?.addMessage({ type: 'limit_reached', text: responseData.error });
                chatApi?.setLimitReached(true);
            } else {
                notify(responseData.error);
            }
        },
        onSessionCreated: (responseData) => {
            if (responseData.chat_status === 'approaching_limit') {
                window.conversationalChatApi?.setApproachingLimit(true);
            }
        },
    },
    applicant_message_generation: {
        selectors: {
            "selector-1": new Selector("ckEditorTemplate", () => CKEDITOR.instances['message-message']),
        },
        getAdditionalParams: () => {
            const userPrompt = $("#user_prompt").val();
            let params = {}
            if (userPrompt) {
                params = {...params, "user_prompt": userPrompt}
            }
            return params
        },
        postGenerateFunc: (callback) => {
            intercomTrackEvent('AI: Message Generation');
            callback();
        },
    },
}

export default TAHireAssistants
